import { render, staticRenderFns } from "./MovimentacaoAtestado.vue?vue&type=template&id=58628250&scoped=true&"
import script from "./MovimentacaoAtestado.vue?vue&type=script&lang=js&"
export * from "./MovimentacaoAtestado.vue?vue&type=script&lang=js&"
import style0 from "./MovimentacaoAtestado.vue?vue&type=style&index=0&id=58628250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58628250",
  null
  
)

export default component.exports